module.exports = "https://r.zoocdn.com/_next/static/images/rbs-a10ca181e07ce4506a26ce45f86e2a4c.svg";